import React, { Component, PropTypes } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Project from '../components/Project';
import Highlight from 'react-highlight';

import { connect } from 'react-redux';
const { Link } = require('react-router')




//Change Class per Project
class Portfolio extends React.Component {
  render () {
    const { projects, benchmark, personalInfo } = this.props;  
    console.log(personalInfo);
    
    const featProject = projects[2];

    // const params = this.props.params || {}
    // const { title, description, year, poster, trailer } = params
    return (
      <div className='container'>
        <Header personalInfo={personalInfo} />
        <div className=''>

         <div className='back-button'>
          <Link to='/'>
          <span className="glyphicon glyphicon-chevron-left"></span>
            Back to projects
          </Link>
          </div>

          <Project project={featProject}/>


        </div>

        <div className='case-study col-md-12 col-xs-12'>

        <h1>

        </h1>

        <p>
          My portfolio, currently in its first iteration, was built using React, React Router, Webpack and Redux.  Version control and hosting are handled by Git.
          </p>


          <h4>
          Project Structure 
          </h4>


          <p>
          Initially I wanted to create a version that would pull data from a JSON file and create all pages dynamically.  
          I structured the data as a JSON file, used a reducer to load it into redux and passed into React as props.  I used Object.map to unpack the data objects and create the home page image gallery.
          </p>

          <pre>{`
           const projectEntries = projects.map((project, index) => {
              return <Project key={index} project={project} />;
          });
          `}</pre> 
          

          <p>
          I realized, that however, each project would need a case study and that each case study would need a different page structure.
          </p>

          <p>
          I decided to create an individual page for each project, link them with the react-router, but still have the project data persist in a redux layer making it easily accessible from any page.  
          </p>

             <pre>{`
          <Provider store={store}>
             <Router history={hashHistory}>
                <Route path='/' component={Layout}>
                  <IndexRoute component={App} /> 
                  <Route path='/pages/Volkno' component={Volkno}  />   
                  <Route path='/pages/MobileReddit' component={MobileReddit}  />  
                  ....
     
                </Route>
              </Router>
          </Provider>
          `}</pre>

          <pre>{`
          function mapStateToProps(state) {
            return {
              projects: state.projects,
              personalInfo: state.personalInfo
            };
          }

          //Change for each project

          export default connect(mapStateToProps)(Portfolio)
          `}</pre>

          <p>
          The page links persist in the description and are generated dynamically.  This will make it easy to add new projects.  Each page connects directly to the redux store and gets it props from there.  Passing data around (data tunneling) in React seems to be very open ended so I’m still experimenting with several different options.
          </p>


        


          <p>
          This definitely increases setup time and project complexity, and in the future I think I will leave it out for a project this small.  
          </p>


          Next steps include adding some animations using state in React.

        </div>
        <Footer personalInfo={personalInfo} />
      </div>
    )
  }
}

const { object, array } = React.PropTypes

Portfolio.propTypes = {
  projects: PropTypes.array.isRequired,
  personalInfo: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.projects,
    personalInfo: state.personalInfo
  };
}

//Change for each project

export default connect(mapStateToProps)(Portfolio)




/** WEBPACK FOOTER **
 ** ./src/pages/Portfolio.js
 **/